import { DataSourceBaseValueBase } from "abweb/dto/generated/ds/DataSourceBaseValueBase";
export class DataSourceBaseValue extends DataSourceBaseValueBase {
  get hasRef() {
    // Hi mom
    return this.refID != null;
  }
  get fieldType() {
    if (this.fieldTypeOverwrite != null) {
      return this.fieldTypeOverwrite;
    }
    return super.getFieldType();
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=DataSourceBaseValue.js.map
